import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/service/auth.service';
import { EventService } from 'src/app/core/service/event.service';
import { LEFT_SIDEBAR_TYPE_CONDENSED, LEFT_SIDEBAR_TYPE_DEFAULT } from '../config/layout.model';
import { BrandItem } from '../models/brands.model';
import { CreateNewMenuOption } from '../models/create-new.model';
import { Language } from '../models/language.model';
import { MegaMenuItem } from '../models/mega-menu.model';
import { ProfileOptionItem } from '../models/profileoption.model';
import { SearchResultItem, SearchUserItem } from '../models/search.model';
import { TranslateService } from '@ngx-translate/core';
import { changeBodyAttribute } from '../helper/utils';
import { User, UserRole } from 'src/app/core/models/auth.models';
import { NotificationService } from 'src/app/pages/projects/services/notification.service';
import { first, takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UtilsService } from 'src/app/core/service/utils.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { TimesInfoTopBarComponent } from 'src/app/pages/projects/board/times-info-top-bar/times-info-top-bar.component';
import { BoardMainScreenService } from 'src/app/pages/projects/board/board-main-screen/board-main-screen.service';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  destroy5$: Subject<boolean> = new Subject<boolean>();
  destroy6$: Subject<boolean> = new Subject<boolean>();
  destroy3$: Subject<any> = new Subject<any>()
  destroy4$: Subject<any> = new Subject<any>()
  destroy7$: Subject<any> = new Subject<any>()
  @Input() layoutType: string = '';
  @Input() leftSidebarTheme: string = 'light';

  @ViewChild('infoTopBar') infoTopBar: TimesInfoTopBarComponent;
  @ViewChild('taskToggle') taskToggle: OverlayPanel | null = null;

  createMenuOptions: CreateNewMenuOption[] = [];
  megaMenuItems: MegaMenuItem[] = [];
  notificationList: any = [];
  languages: Language[] = [];
  brands: BrandItem[] = [];
  profileOptions: ProfileOptionItem[] = [];
  selectedLanguage?: Language;
  searchResults: SearchResultItem[] = [];
  searchUsers: SearchUserItem[] = [];
  accountPhoto: any = 'null';

  totalNotRead: number = 0;
  isActive:boolean  =false;

  loggedInUser: User | null = null;
  topnavCollapsed: boolean = false;

  // output events
  @Output() mobileMenuButtonClicked = new EventEmitter();
  @Output() settingsButtonClicked = new EventEmitter<boolean>();

  constructor(
    private authService: AuthenticationService,
    private eventService: EventService,
    private notificationsService: NotificationService,
    private utilSrv: UtilsService,
    private translateService: TranslateService,
    private boardMainScreen: BoardMainScreenService,
    public router: Router,
  ) {

  }

  ngOnInit(): void {

    this.loggedInUser = this.authService.currentUser;
    
    if(this.loggedInUser)
    this.isActive = this.loggedInUser?.hasActiveTask;

    
    this._fetchMenus();
    this._fetchLanguages();
    this._fetchProfileOptions();
    //this.loadNotifications();
    document.addEventListener('fullscreenchange', this.exitHandler);
    document.addEventListener("webkitfullscreenchange", this.exitHandler);
    document.addEventListener("mozfullscreenchange", this.exitHandler);

    this.accountPhoto = this.loggedInUser?.urlPhoto;
    if (!this.accountPhoto) this.accountPhoto = '../../../../assets/images/user-avatar.jpg';

    this.notificationsService.realoadNotifications.pipe(
      takeUntil(this.destroy$)
    ).subscribe((reload) => {
      //this.loadNotifications();
    })

    this.boardMainScreen.closeOverlayTask.pipe(
      takeUntil(this.destroy5$)
    ).subscribe((reload) => {
      this.closeOverlay();
    })

    this.boardMainScreen.trackingRunningTopBar.pipe(
      takeUntil(this.destroy6$)
    ).subscribe((active:boolean) => {
      this.isActive = active
    })

    this.boardMainScreen.trackingRunning.pipe(
      takeUntil(this.destroy7$),
    ).subscribe((value: any) => {
      if (value) {
        this.isActive = value.status;
      }
    })


  }
  get userRole(): any {
    return UserRole
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.destroy3$.next(null);
    this.destroy3$.unsubscribe();
    this.destroy4$.next(null);
    this.destroy4$.unsubscribe();
    this.destroy5$.next(true);
    this.destroy5$.unsubscribe();
    this.destroy6$.next(false);
    this.destroy6$.unsubscribe();
    this.destroy7$.next(null);
    this.destroy6$.unsubscribe();
  }

  /**
   * fetches menu options
   */
  _fetchMenus(): void {
    this.createMenuOptions = [
      {
        id: 1,
        label: 'TOP_MENU.PROJECT_REQUEST',
        icon: 'mdi mdi-application-brackets',
        link: '/sales/request',
      },
      // {
      //   id: 2,
      //   label: 'TOP_MENU.QUOTE_REQUEST',
      //   icon: 'mdi mdi-application',
      //   link: undefined
      // }
    ];
  }

  loadNotifications() {
    this.notificationsService.getNotificationsForTopBar().pipe(first()).subscribe((response) => {
      this.notificationList = response.data;
      this.totalNotRead = response.metadata.totalUnread;
    })
  }

  /**
   * Fetches supported languages
   */
  _fetchLanguages(): void {
    this.languages = [{
      id: 1,
      locale: 'en',
      name: 'English',
      flag: 'assets/images/flags/australia.jpg',
    },
    {
      id: 2,
      locale: 'pt',
      name: 'Portugal',
      flag: 'assets/images/flags/portugal.jpg',
    }];

    // INIT LANGAUGE
    this.changeLanguage();
  }

  /**
   * Fetches profile options
   */
  _fetchProfileOptions(): void {
    this.profileOptions = [
      /* {
        label: 'TOP_USER_MENU.PROFILE',
        icon: 'mdi mdi-account',
        redirectTo: `/users/profile`,
      },
      {
        label: 'TOP_USER_MENU.LOCKSCREEN',
        icon: 'mdi mdi-account-lock',
        redirectTo: '/auth/lock-screen',
      }, */
      {
        label: 'MISC.LOGOUT',
        icon: 'mdi mdi-logout',
        redirectTo: '/auth/logout',
      }
    ];

  }

  /**
   * changes left sidebar width 
   */
  changeSidebarWidth(): void {
    if (document.body.hasAttribute('data-sidebar-size') && document.body.getAttribute('data-sidebar-size') === "condensed") {
      this.eventService.broadcast('changeLeftSidebarType', LEFT_SIDEBAR_TYPE_DEFAULT);
      changeBodyAttribute("data-sidebar-size", LEFT_SIDEBAR_TYPE_DEFAULT);
    }
    else {
      this.eventService.broadcast('changeLeftSidebarType', LEFT_SIDEBAR_TYPE_CONDENSED);
      changeBodyAttribute("data-sidebar-size", LEFT_SIDEBAR_TYPE_CONDENSED);
    }
  }

  /**
   * exit handler for full screen mode
   */
  exitHandler(): void {
    let document: any = window.document;

    if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
      document.body.classList.remove('fullscreen-enable');
    }
  }

  /**
   * toggles full screen mode
   */
  toggleFullScreen(): void {
    let document: any = window.document;

    document.body.classList.toggle('fullscreen-enable');

    let elem = document.querySelector('.maximize-icon');

    if (elem.hasAttribute('data-toggle') && document.body.getAttribute('data-toggle') === "fullscreen") {
      document.body.removeAttribute('data-toggle');
    }
    else {
      elem.setAttribute('data-toggle', 'fullscreen')
    }

    if (!document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  changeLanguage(language?: Language): void {
    if (language) {
      this.selectedLanguage = language;
    } else {

      const localLang = localStorage.getItem('lang');
      if (localLang) {
        const checkLanguage = this.languages.find(l => l.locale === localLang);
        if (checkLanguage)
          return this.changeLanguage(checkLanguage);
      } else {
        const browserLang = this.translateService.getBrowserLang();
        const checkLanguage = this.languages.find(l => l.locale === browserLang);
        if (checkLanguage)
          return this.changeLanguage(checkLanguage);

      }

      this.selectedLanguage = this.languages[0];
    }

    localStorage.setItem('lang', this.selectedLanguage.locale);
    this.translateService.use(this.selectedLanguage.locale);
  }

  getSelectedLanguageFlag() {
    if (!this.selectedLanguage) {
      this.changeLanguage();
    }

    return this.selectedLanguage?.flag;
  }

  moveToNotificationScreen(id?: number) {
    if (id) {
      this.router.navigate([`/notifications/${id}`]);
    } else {
      this.router.navigate(['/notifications']);
    }
  }
  /**
  * Toggles the right sidebar+
  */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }


  /**
 * Toggle the menu bar when having mobile screen
 */
  toggleMobileMenu(event: any) {
    this.topnavCollapsed = !this.topnavCollapsed;
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  markAsRead(event: any, id: number) {
    event.stopPropagation();
    this.notificationsService.updateNotification(id).pipe(first()).subscribe((response) => {
      this.notificationList.find((value: { id: number; }) => value.id === id).read = true
    }, error => {
      this.utilSrv.toast(`${this.translateService.instant('NOTIFICATIONS.UPDATEERROR')}: ${error}`, 'error', false);
    });
  }

  notifyIcon() {
    this.loadNotifications();
    if (window.innerWidth < 610) {
      this.moveToNotificationScreen();
    }
  }

  profileIcon() {
    if (window.innerWidth < 610) {
      this.router.navigate([`/users/profile`]);
    }
  }
  selectMobileLanguage() {
    if (window.innerWidth < 610) {
      if (this.selectedLanguage?.id == 1) {
        this.selectedLanguage = this.languages[1];
      } else if (this.selectedLanguage?.id == 2) {
        this.selectedLanguage = this.languages[0];
      }
    }

  }

  clickTask() {

    this.infoTopBar?.loadTaskInfo();
  }

  closeOverlay() {
    this.taskToggle?.hide()
  }


}
